import { AuthProvider, type User } from '@/types';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(email: string): boolean {
  return EMAIL_PATTERN.test(email.trim());
}

export function userHasPaymentEmail(user: User | null): boolean {
  return Boolean(user?.email?.trim());
}

export function isGoogleAuthWithEmail(user: User | null): boolean {
  return user?.authProvider === AuthProvider.GOOGLE && userHasPaymentEmail(user);
}

export function resolveCheckoutEmail(user: User | null): string {
  return user?.email?.trim() ?? '';
}
